export default function ConfidenceGauge({
  value,
  size = "lg",
}: {
  value: number;
  size?: "sm" | "md" | "lg";
}) {
  const percentage = Math.round(value * 100);
  const circumference = 2 * Math.PI * 45;
  const strokeDashoffset = circumference - value * circumference;

  const getColor = () => {
    if (percentage >= 70) return "text-emerald-500";
    if (percentage >= 60) return "text-amber-500";
    return "text-red-500";
  };

  const sizeClasses = {
    sm: "w-16 h-16",
    md: "w-24 h-24",
    lg: "w-32 h-32",
  };

  const textSizes = {
    sm: "text-sm",
    md: "text-2xl",
    lg: "text-3xl",
  };

  return (
    <div className={`relative ${sizeClasses[size]}`}>
      <svg
        className="w-full h-full -rotate-90"
        viewBox="0 0 100 100"
        aria-label="Confiança de detecção"
        role="img"
      >
        <circle
          cx="50"
          cy="50"
          r="45"
          fill="none"
          stroke="currentColor"
          strokeWidth="8"
          className="text-muted/30"
        />
        <circle
          cx="50"
          cy="50"
          r="45"
          fill="none"
          stroke="currentColor"
          strokeWidth="8"
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
          className={`${getColor()} transition-all duration-1000 ease-out`}
        />
      </svg>
      <div className="absolute inset-0 flex items-center justify-center">
        <span className={`${textSizes[size]} font-bold ${getColor()}`}>
          {percentage}%
        </span>
      </div>
    </div>
  );
}
